import { enUS } from 'date-fns/locale'
import { format } from 'date-fns'

import { Language } from 'src/types'
import { TIME_IN_MS } from 'src/constants'

import { localeMap } from 'src/helpers/formatDateByLang/constants'

export const formattedDateByLang = (
  time: number,
  language: Language,
): string => {
  return format(new Date(time * TIME_IN_MS.SECOND), 'dd MMMM yyyy, HH:mm', {
    locale: localeMap[language] || enUS,
  })
}
